import {
  CriticalDeviceIcon,
  SignalLostIcon,
  IdleCupIcon,
  ServiceWrenchIcon,
  PlaymakerTruckIcon,
  CriticalQuotaIcon,
  NoOrderIcon,
  LowPerformanceIcon,
} from "../../atoms/animatedIcons";
import getSeverityStyles from "./alertSeverityStyles";

const ICONS = {
  criticalDevice: CriticalDeviceIcon,
  signalLost: SignalLostIcon,
  idleCup: IdleCupIcon,
  serviceWrench: ServiceWrenchIcon,
  playmakerTruck: PlaymakerTruckIcon,
  criticalQuota: CriticalQuotaIcon,
  noOrder: NoOrderIcon,
  lowPerformance: LowPerformanceIcon,
};

/**
 * Molekül: uyarı tipinin hareketli ikonu, önem rengindeki yuvarlak zeminde.
 * Sayısı 0 olan kategoride ikon gri ve hareketsizdir.
 */
export default function AlertCategoryIcon({ iconKey, severity, isClear = false, size = "md" }) {
  const Icon = ICONS[iconKey] || CriticalDeviceIcon;
  const styles = getSeverityStyles(severity, isClear);
  const box = size === "sm" ? "w-9 h-9 rounded-lg" : "w-12 h-12 rounded-xl";
  const icon = size === "sm" ? "w-5 h-5" : "w-6 h-6";
  return (
    <span className={`inline-flex shrink-0 items-center justify-center ring-1 ${box} ${styles.tile}`}>
      <Icon className={icon} animated={!isClear} />
    </span>
  );
}
